<title>{{ apiReferenceResponsePage.htmlTitle }}</title>
<app-api-reference-accordion-section
  [apiReferenceAccordianSections]="apiReferenceResponsePage.schemaDataModelAccordianSections"
  [responsePage]="true"
  [isDefault]="false"
></app-api-reference-accordion-section>
<div class="mt-4 mb-4">
  <app-api-reference-note-section *ngIf="apiReferenceResponsePage.noteSections?.length" [noteSections]="apiReferenceResponsePage.noteSections || []"> </app-api-reference-note-section>
</div>
<app-api-reference-details-xml-section [pageName]="pageName" [apiReferenceDetailXMLSections]="apiReferenceResponsePage.apiReferenceDetailXMLSections"> </app-api-reference-details-xml-section>
